import * as React from 'react';

import type {
  ContentCardContext as ContentCardContextType
} from 'components/cards/content-card/types';

const ContentCardContext = React.createContext<ContentCardContextType | null>(null);

export default ContentCardContext;
